export const formatUserFirstLast = (firstName?: string | null, lastName?: string | null) => {
  if (!firstName && !lastName) return '';
  return `${firstName ?? ''}${firstName && lastName ? ' ' : ''}${lastName ?? ''}`;
};
